import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import { ensureBit, includeBit } from '../../../utils/util';
import { NotificationTypes } from '../../../utils/constants';
import { updateSelfUser } from '../../../database/repositories/UserRepository';

function UserEmail() {
  const userData = useSelector((state) => state.auth.user_data);
  const [notifications, setNotications] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userData) setNotications(userData?.notifications ?? 0);
  }, [userData]);

  const ensureNotifications = (type) => {
    setNotications(ensureBit(NotificationTypes[type], notifications));
  };

  const NotificationMessages = {
    ProdutSold: 'Você vendeu um produto',
    AdQuestion: 'Fizeram uma pergunta no seu anúncio',
    AdEnded: 'Seu anúncio foi finalizado',
    PurchasedProduct: 'Você comprou um produto',
    SelfOffer: 'Você usou a auto-oferta',
    AdIsAboutToEnd: 'Seu anúncio está quase finalizado',
    newMessages: 'Escreveram para você pelo sistema de mensgens',
    Promotions: 'Ofertas e promoções da Kacareco'
  };

  const onSave = async () => {
    setLoading(true);
    await updateSelfUser({ notifications });
    setLoading(false);
  };

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <NavBar />
      <MainContent>
        <S.UserSoldContainer>
          <ProfileCardMenu />
          <S.UserSoldRightContainer>
            <S.UserEmailTitle>
              <i className="far fa-envelope" /> E-MAIL
            </S.UserEmailTitle>
            <S.MsgFunctionality>QUAIS E-MAILS VOCÊ QUER RECEBER?</S.MsgFunctionality>
            <S.EmailSettingsContainer>
              <lu>
                {Object.entries(NotificationMessages).map(([type, message]) => (
                  <li className="email-status-config">
                    {message}
                    <label onClick={() => ensureNotifications(type)}>
                      <span className="email-checkbox-wrapper">
                        <i
                          className="fas fa-check"
                          style={
                            includeBit(NotificationTypes[type], notifications)
                              ? {}
                              : { color: 'white' }
                          }
                        />
                      </span>
                    </label>
                  </li>
                ))}
              </lu>
            </S.EmailSettingsContainer>
            <S.UserSoldContainerBot>
              <div>
                Você continuará recebendo e-mails sobre suas compras, vendas e outras transações,
                assim como comunicações importantes relacionadas à sua conta.
              </div>
              {loading ? <button>Salvando...</button> : <button onClick={onSave}>Salvar</button>}
            </S.UserSoldContainerBot>
          </S.UserSoldRightContainer>
        </S.UserSoldContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default UserEmail;
